export default __webpack_public_path__ + "static/media/formulario-traslados.f9c0521a.pdf";